
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22 13.3636V11.0909H2V13.3636L4.95 13.7664C5.12354 14.4594 5.39929 15.1227 5.76818 15.7345L3.96455 18.1073L5.89273 20.0355L8.26545 18.2291C8.87728 18.598 9.54061 18.8737 10.2336 19.0473L10.6364 22H13.3636L13.7664 19.05C14.4594 18.8765 15.1227 18.6007 15.7345 18.2318L18.1073 20.0355L20.0327 18.1073L18.2291 15.7345C18.598 15.1227 18.8737 14.4594 19.0473 13.7664L22 13.3636ZM12.3536 9.44444L12 9.79799L11.6464 9.44444L10.5556 8.35355L10.202 8L10.9091 7.29289L11.2627 7.64645L11.5 7.88377V3.63634V3.13634H12.5V3.63634V7.88377L12.7373 7.64645L13.0909 7.29289L13.798 8L13.4444 8.35355L12.3536 9.44444ZM7.90912 9.79799L8.26267 9.44444L9.35355 8.35355L9.70711 8L9 7.29289L8.64645 7.64645L8.40912 7.88377V6.2727V5.98334L8.15823 5.83918L5.80733 4.48827L5.3738 4.23915L4.87557 5.1062L5.30909 5.35531L7.40912 6.56206V7.88377L7.17179 7.64645L6.81824 7.29289L6.11113 8L6.46468 8.35355L7.55557 9.44444L7.90912 9.79799ZM16.4437 9.44444L16.0902 9.79799L15.7366 9.44444L14.6457 8.35355L14.2922 8L14.9993 7.29289L15.3528 7.64645L15.5902 7.88377V6.2727V5.98334L15.841 5.83918L18.192 4.48827L18.6255 4.23915L19.1237 5.1062L18.6902 5.35531L16.5902 6.56206V7.88377L16.8275 7.64645L17.181 7.29289L17.8882 8L17.5346 8.35355L16.4437 9.44444Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowapiexternalFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
